import * as Headless from '@headlessui/react';
import Text from '@/components/Text';
import cn from '@/utils/cn';
import isString from '@/utils/typeGuards/isString';

type TProps = { className?: string; shouldLocalize?: boolean } & Omit<
  Headless.DescriptionProps,
  'as' | 'className'
>;

export const Description = ({
  className,
  children,
  shouldLocalize = true,
  ...props
}: TProps) => {
  const shouldLocalizeText = shouldLocalize && isString(children);

  return (
    <Headless.Description
      data-slot="description"
      {...props}
      className={cn(
        'text-grayscale-darkGray text-sm data-disabled:opacity-50 sm:text-sm/6',
        className
      )}
    >
      {shouldLocalizeText ? <Text>{children}</Text> : children}
    </Headless.Description>
  );
};
